import { Company } from '../companies';

export enum TasksStatusEnum {
  pending = 'pending',
  scheduled = 'scheduled',
  onRoute = 'onRoute',
  done = 'done',
  inProgress = 'inProgress',
  reported = 'reported',
  canceled = 'canceled'
}

export enum TaskLogUpdatedByTypeEnum {
  users = 'users',
  employees= 'employees',
  integrations= 'integrations',
  customers= 'customers',
  system= 'system',
  api= 'api'
}

export enum TaskOrMaintenanceLogUpdatedBySourceEnum {
  browser = 'browser',
  mobile = 'mobile',
  mordor = 'mordor',
  system = 'system',
  vrp = 'vrp',
  api = 'api'
}

export interface ScheduleDateTime {
  date?: Date;
  time?: string;
}

export interface TaskRating {
  id?: string;
  stars?: number;
  comments?: string;
}

export interface TaskEmployee {
  id?: string;
  name?: string;
  avatar?: string;
  avatarUrl?: string;
  uuid?: string;
}

export interface TaskLog {
  id?: string;
  createdAt?: string;
  updatedBy?: {
    id?: string;
    name?: string;
    type?: string;
  };
  snapshot?: TaskSnapshot;
}

export interface TaskSnapshot {
  id: string;
  company: Company;
  scheduled: ScheduleDateTime;
  startedAt: Date;
  completedAt: Date;
  status: TasksStatusEnum;
  statusDescription: string;
  latitude: number;
  longitude: number;
  position: number;
  archived: boolean;
  receivedAt: Date;
  viewedAt: Date;
  employee: TaskEmployee;
  rating: TaskRating;
}

export interface Task {
  id?: string;
  timezone?: string;
  status: TasksStatusEnum;
  statusDescription?: string;
  employee?: TaskEmployee;
  scheduled?: ScheduleDateTime;
  startedAt?: string;
  completedAt?: string;
  createdAt: string;
  updatedAt: string;
  archived: boolean;
  rating: TaskRating;
  logs?: TaskLog[];
}
